import React, {Component} from 'react';
import {Row, Col, Radio, Spin, Form, Input, Button, Select} from 'antd';
import Card from '../../components/Card';
import {api, app} from "../../app";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const FormItem = Form.Item;
const Option = Select.Option;

class AraeSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pro_load_index: 0,
            city_load_index: 0,
            provinceList: [],
            cityList: [],
            teamList: [],
            cityInfo: {},
        }
    };

    componentDidMount() {
        this._isMounted = true;
        this.ProvinceData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data, cb) => {
        if (this._isMounted) {
            this.setState(data, () => {
                if (cb) cb();
            });
        }
    }

    /**
     * 省份列表
     **/
    ProvinceData = () => {
        this.setData({p_loading: true}, async () => {
            const params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            };
            let {flag, data, msg} = await app.post(api.ProvinceCityList, params);
            if (flag !== 1) {
                app.alert(msg, "error");
                data = [];
            }
            const cityList = data[0].city || [];
            let cityInfo = {};
            if (cityList.length > 0) {
                cityInfo = cityList[0];
                cityInfo.multeam_name = data[0].multeam_name;
                cityInfo.prefix = cityInfo.multeam_name;
                // let {city_code} = cityInfo;
                // this.props.form.setFieldsValue({city_code});
            }
            this.setData({p_loading: false, provinceList: data, cityList, cityInfo, t_loading: true}, async () => {
                await this.TeamData(cityInfo.city_id);
            });
        });
    }

    /**
     * 管理特殊列表
     **/
    manageData = async (city_id) => {
        let params = {
            city_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let {flag, data, msg} = await app.post(api.ManageDepartmentPrefix, params);
        if (flag === 1) {
            data.prefix = data.multeam_name;
            return data;
        } else {
            app.alert(msg, "error");
            return {};
        }
    }

    /**
     * 队伍列表
     **/
    TeamData = async (city_id) => {
        const params = {
            city_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let {flag, data, msg} = await app.post(api.CityTeamList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        this.setData({t_loading: false, teamList: data});
    }

    /**
     * 省份选择
     **/
    handleSelectPro = (e) => {
        const {provinceList} = this.state, index = parseInt(e.target.value), pro = provinceList[index];
        const cityList = pro.city || [];
        let cityInfo = {};
        if (cityList.length > 0) {
            cityInfo = cityList[0];
            cityInfo.multeam_name = pro.multeam_name;
            cityInfo.prefix = cityInfo.multeam_name;
            this.props.form.setFieldsValue({city_code: cityInfo.city_code});
        }
        this.setData({pro_load_index: index, city_load_index: 0, cityList, cityInfo, t_loading: true}, async () => {
            await this.TeamData(cityInfo.city_id);
        });
    }

    /**
     * 市区选择
     **/
    handleSelectCity = async (e) => {
        const index = parseInt(e.target.value);
        const {cityList, cityInfo} = this.state;
        let cityInfo2 = cityList[index];
        if (cityInfo.province_id === '27') {
            cityInfo2 = await this.manageData(cityInfo2.city_id);
        } else {
            cityInfo2.multeam_name = cityInfo.multeam_name;
            cityInfo2.prefix = cityInfo2.multeam_name;
        }
        this.props.form.setFieldsValue({city_code: cityInfo2.city_code});
        this.setData({city_load_index: index, cityInfo: cityInfo2, t_loading: true}, async () => {
            await this.TeamData(cityInfo2.city_id);
        });
    }

    /**
     * 修改提交
     * @param e
     */
    handleUpdateSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values);
                this.setData({update_loading: true}, async () => {
                    let {cityList, cityInfo, city_load_index, teamList} = this.state;
                    let {team, city_code} = values;
                    let params = {
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                    };
                    if (team || team === 0) {
                        let teamInfo = teamList[team];
                        params.team_id = teamInfo.team_id;
                        params.team_code = city_code;
                        let {flag, msg} = await app.post(api.EditTeamCode, params);
                        if (flag === 1) {
                            app.alert("修改成功", "success");
                            teamList[team].team_code = city_code;
                            this.setData({teamList});
                        } else {
                            app.alert(msg, "error");
                        }
                    } else {
                        params.city_code = city_code;
                        params.city_id = cityInfo.city_id;
                        let {flag, msg} = await app.post(api.EditCityCode, params);
                        if (flag === 1) {
                            app.alert("修改成功", "success");
                            cityList[city_load_index].city_code = values.city_code;
                            cityInfo.city_code = values.city_code;
                            this.setData({cityList, cityInfo});
                        } else {
                            app.alert(msg, "error");
                        }
                    }
                    this.setData({update_loading: false});
                });
            }
        });
    }

    /**
     * 队伍选择器更改值
     * @param value
     */
    handleTeamChange = (value) => {
        let {cityInfo, teamList} = this.state, team = teamList[value];
        if (value === undefined) {
            cityInfo.prefix = cityInfo.multeam_name;
            this.props.form.setFieldsValue({city_code: ''});
        } else {
            cityInfo.prefix = team.city_code;
            this.props.form.setFieldsValue({city_code: team.team_code});
        }
        this.setData({cityInfo});
    }

    render() {
        let style = {
                padding: 25,
                height: 'calc(100% - 68px)',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee',
            },
            {getFieldDecorator, getFieldValue} = this.props.form,
            formItemLayout = {
                labelCol: {span: 8},
                wrapperCol: {span: 15, offset: 1},
            },
            {provinceList, p_loading, pro_load_index, cityList, city_load_index, cityInfo, update_loading, t_loading, teamList} = this.state;
        return (
            <div className="area-set">
                <Row className="area-cards">
                    {/*<Col span={5} className="area-card">*/}
                    {/*    <Card width="100%" height="100%" style={style} title="省份">*/}
                    {/*        {*/}
                    {/*            p_loading ?*/}
                    {/*                (*/}
                    {/*                    <Row className="data-loading" type="flex" align="middle" justify="center">*/}
                    {/*                        <Spin size="small"/>*/}
                    {/*                    </Row>*/}
                    {/*                ) :*/}
                    {/*                (*/}
                    {/*                    <RadioGroup onChange={this.handleSelectPro} className="items"*/}
                    {/*                                value={pro_load_index}>*/}
                    {/*                        {*/}
                    {/*                            provinceList.map((pro, index) => {*/}
                    {/*                                return (*/}
                    {/*                                    <RadioButton key={index + 1} className='no-select'*/}
                    {/*                                                 value={index}>*/}
                    {/*                                        <div title={pro.area_name}>{pro.area_name}</div>*/}
                    {/*                                    </RadioButton>*/}
                    {/*                                )*/}
                    {/*                            })*/}
                    {/*                        }*/}
                    {/*                    </RadioGroup>*/}
                    {/*                )*/}
                    {/*        }*/}
                    {/*    </Card>*/}
                    {/*</Col>*/}
                    {/*<Col span={5} offset={1} className="area-card">*/}
                    {/*    <Card width="100%" height="100%" style={style} title="市/区">*/}
                    {/*        <RadioGroup onChange={this.handleSelectCity} className="items"*/}
                    {/*                    value={city_load_index}>*/}
                    {/*            {*/}
                    {/*                cityList.length > 0 ?*/}
                    {/*                    cityList.map((city, index) => {*/}
                    {/*                        return (*/}
                    {/*                            <RadioButton key={index + 1} className='no-select' value={index}>*/}
                    {/*                                <div title={city.city_name}>{city.city_name}</div>*/}
                    {/*                            </RadioButton>*/}
                    {/*                        )*/}
                    {/*                    }) : (<p style={{textAlign: "center", padding: "20px 0"}}>无对应市/区</p>)*/}
                    {/*            }*/}
                    {/*        </RadioGroup>*/}
                    {/*    </Card>*/}
                    {/*</Col>*/}
                    <Col span={12} offset={1} className="area-card">
                        <Card width="100%" justify="center" style={style} title="设置">
                            <Form onSubmit={this.handleUpdateSubmit}>
                                {
                                    <FormItem
                                        {...formItemLayout}
                                        label="队伍列表"
                                    >
                                        {
                                            t_loading ? (<Spin size="small"/>) :
                                                (teamList.length > 0 ?
                                                    (getFieldDecorator('team')(
                                                        <Select notFoundContent="无队伍" placeholder="请选择队伍"
                                                                onChange={this.handleTeamChange} allowClear>
                                                            {
                                                                teamList.map((team, index) => {
                                                                    return (
                                                                        <Option key={index}
                                                                                value={index}>{team.teamname}</Option>);
                                                                })
                                                            }
                                                        </Select>
                                                    )) : (<span style={{color: "#999"}}>暂无队伍</span>))
                                        }
                                    </FormItem>
                                }
                                <FormItem
                                    {...formItemLayout}
                                    label="存心编号前缀"
                                >{getFieldDecorator('city_code')(
                                    // <Input addonBefore={cityInfo.prefix} placeholder="请设置存心编号前缀"/>
                                    <Input placeholder="请设置存心编号前缀"/>
                                )}
                                    <span className="ant-form-text" style={{lineHeight: '24px'}}>注：编号前缀用于系统自动生成【存心编号】，统一设置为2位大写字母。<br/>当前设置存心编号前缀为：{getFieldValue("city_code") || '无'}</span>
                                </FormItem>
                                <div style={{textAlign: "center", marginTop: 30}}>
                                    <Button type="primary" loading={update_loading} htmlType="submit">修改</Button>
                                </div>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Form.create()(AraeSet);



// WEBPACK FOOTER //
// ./src/routes/grade/AraeSet.jsx